<template>
  <div class="d-flex flex-column justify-content-between">
    <div class="d-flex flex-column">
      <div>
        <span class="font-kanit-regular-14 text-kanit-color-grey">เอกสารไม่บังคับสามารถเลือกอัปโหลดเป็นบางรายการ
          อัปโหลดทั้งหมด
          หรือไม่อัปโหลดเลย</span>
      </div>
      <div class="justify-content-md-center" v-for="(item, key) in documentTypes" :key="key">
        <template>
          <b-card class="card-border-radius common-shadow mt-3" :class="['danger', 'warning'].includes(checkBorderColor(item.state))
            ? 'card-warning'
            : 'noborder'
            ">
            <b-row>
              <b-col col="1" v-if="item.state === 'success'" cols="1" align-self="center">
                <template v-if="item.state === 'success'">
                  <b-iconstack font-scale="1.5">
                    <b-icon stacked icon="circle-fill" class="text-kanit-color-success"></b-icon>
                    <b-icon stacked icon="check" style="color: #fff"></b-icon>
                  </b-iconstack>
                </template>
              </b-col>
              <b-col>
                <span class="font-kanit-bold-16" style="
                    vertical-align: sub;
                    white-space: normal;
                    word-break: break-word;
                  " :class="item.state === 'success'
                    ? 'text-revamp-color-after-success'
                    : 'text-kanit-color-black'
                    ">
                  {{ item.doc_short_name }}
                </span>
              </b-col>
              <b-col cols="1" class="px-0" v-b-toggle="'my-collapse-' + item.doc_code"
                style="line-height: 32px; padding-right: 32px !important">
                <b-icon v-if="item.state != 'success'" icon="chevron-up" font-scale="1.3" style="margin-bottom: 25%"
                  :class="item.collapse ? 'chevron-up' : 'chevron-down'" class="text-revamp-color-blue" />
              </b-col>
            </b-row>
            <b-row v-if="item.state !== 'success'">
              <b-col class="font-anuphan-regular-14">
                <span class="font-kanit-regular-14" :class="item.state == 'overlimit'
                  ? 'text-kanit-color-danger'
                  : 'text-kanit-color-grey'
                  ">{{
                    item.state == "overlimit" ? "ขนาดเกินมา" : "เหลือพื้นที่"
                  }}
                  <b :class="item.state == 'overlimit'
                    ? 'text-kanit-color-danger'
                    : 'text-revamp-color-size-black'
                    ">{{
                      getFileSizeAndType(
                        Number(
                          item.filesReal.length > 0
                            ? Math.abs(item.totalFileSize)
                            : item.max_size * (1000 * 1000)
                        )
                      )
                    }}
                  </b>
                </span>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col cols="1" class="pt-1"></b-col>
              <b-col>
                <span class="text-kanit-color-success font-kanit-bold-14" style="vertical-align: sub">
                  อัปโหลดสำเร็จ
                </span>
              </b-col>
              <b-col cols="1"></b-col>
            </b-row>

            <b-row v-if="item.state == 'error'" class="pt-1">
              <b-col>
                <span class="text-kanit-color-orange font-kanit-bold-14">อัปโหลดไม่สำเร็จ กรุณาลองใหม่อีกครั้ง
                  หรือข้ามการอัปโหลดเอกสารนี้</span>
              </b-col>
              <b-col cols="1"></b-col>
            </b-row>
            <div v-if="
              item.state == 'error' ||
              item.state == 'wait' ||
              item.state == 'attachfile'
            " />

            <b-collapse :id="'my-collapse-' + item.doc_code" visible v-if="item.state != 'success'"
              v-model="item.collapse">
              <b-row>
                <b-col align-self="center">
                  <hr style="height: 1px; width: 100%; background-color: #e5e7eb" />
                </b-col>
              </b-row>
              <b-row class="pt-2">
                <b-col align-self="center">
                  <componentMiniUpload :documentTypeObj="item" :viewRecommend="true"
                    :callback="callbackSetStateDocumentType" :onReceiveNativeCommand="onReceiveNativeCommand" />
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </template>
      </div>
    </div>
    <!-- Btn action -->
    <div>
      <b-row class="mt-3">
        <b-col>
          <button @click="doSubmit()" class="btn btn-block btn-submit-landing-page" type="button"
            style="line-height: 27px" :disabled="!validateState()">
            <span>บันทึก</span>
          </button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { getFileSize } from "@/utils/FileSize.js";
import { Warning } from "@/utils/popup/Warning.js";
export default {
  components: {
    ComponentMiniUpload: () =>
      import("@/components/TemplateNewScreen/CommonMiniUpload.vue"),
  },
  data() {
    return {
      collapseList: [],
      iconUploadsError: require("@/assets/images/ic_landing_error.png"),
      iconUploadsSuccess: require("@/assets/images/ic_landing_success.png"),
      iconUploading: require("@/assets/images/foundationIconSimpleComponentSnackbarUpload.png"),
      iconUploadated: require("@/assets/images/ic_landing_uploaded.png"),
      backArrowLeft: require("@/assets/images/Arrow-narrow-left.png"),
      revampIconResubmit: require("@/assets/images/revamp-resubmit-ic.png"),
      dataIsChange: false,
      documentTypes: [],
      lstDocumentDeviate: this.$route.params.docList,
    };
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  created() {
    this.$event.$on("onGoBackCallback", () => this.goback());
    this.documentTypes = this.lstDocumentDeviate.map((item) => ({ ...item }));
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      // console.error(err);
    }
    this.$event.$emit("update_current_menu", {
      pageCode: "CommonPreUpload",
      pageName: "เอกสารเพิ่มโอกาสพิจารณา",
      previousPage: this.userData.routerPath.landingRevamp,
      isShow: false,
    });
  },
  beforeDestroy() {
    this.$event.$off("onGoBackCallback");
  },
  methods: {
    getFileSizeAndType(fSize) {
      return getFileSize(fSize);
    },
    doSubmit() {
      this.documentTypes
        .filter((i) => i.state == "error")
        .forEach((element) => {
          element.state = "wait";
        });
      this.lstDocumentDeviate.forEach((item) => {
        let data = this.documentTypes.find((i) => i.doc_code === item.doc_code);
        item.filesReal = data.filesReal;
        item.totalFileSize = data.totalFileSize;
        item.state = data.state;
      });
      this.$store.dispatch("setUserData", this.userData);
      this.$forceUpdate();
      this.$router.push({
        name: this.userData.routerPath.landing,
      });
    },
    validateState() {
      if (
        this.documentTypes.some((item) =>
          item.filesReal.some(
            (x) => x.fileHavePassword == true && x.fileCheckassword != true
          )
        )
      ) {
        return false;
      }
      if (this.documentTypes.some((i) => i.state == "overlimit")) {
        return false;
      }
      if (this.lstDocumentDeviate.some((i) => i.state == "success")) {
        return true;
      }
      if (
        this.documentTypes.some((i) => i.state == "attachfile") ||
        this.checkUploadFile()
      ) {
        return true;
      }
      if (this.lstDocumentDeviate.some((i) => i.state == "error")) {
        return false;
      }
      return false;
    },
    checkUploadFile() {
      const changeFilter = this.lstDocumentDeviate.some((itemA) => {
        const itemB = this.documentTypes.find(
          (i) => i.doc_code === itemA.doc_code
        );
        const fCompare = (firstObj, SecondObj) => {
          if (SecondObj.length > 0 && firstObj.length > 0) {
            // console.log(firstObj, SecondObj);
            const result = firstObj.filter((y) => {
              return SecondObj.some((x) => {
                // console.log(x.filename, y.filename, x.filename !== y.filename && x.filesize != y.filesize);
                return x.filename !== y.filename || x.filesize != y.filesize;
              });
            });
            // console.log("result", result);
            return result.length > 0;
          } else if (SecondObj.length !== firstObj.length) {
            // console.log(firstObj.length, SecondObj.length);
            return true;
          } else {
            return false;
          }
        };
        if (itemA.filesReal.length > itemB.filesReal.length) {
          return fCompare(itemA.filesReal, itemB.filesReal);
        } else if (itemA.filesReal.length < itemB.filesReal.length) {
          return fCompare(itemB.filesReal, itemA.filesReal);
        } else {
          return fCompare(itemA.filesReal, itemB.filesReal);
        }
      });
      // console.log("changeFilter", changeFilter);
      return changeFilter;
    },
    goback() {
      if (this.checkUploadFile()) {
        this.alertUnSaveState();
      } else {
        this.routeBack();
      }
    },
    alertUnSaveState() {
      Warning(
        {
          title: "ยืนยันการออกจากหน้านี้?",
          message: "ข้อมูลของคุณจะไม่ถูกบันทึก",
          confirmButtonText: "ออกจากหน้านี้",
          cancelButtonText: "ยกเลิก",
          confirmCallBack: () => {
            this.routeBack();
          },
        },
        this.$swal
      );
    },
    routeBack() {
      this.$router.push({
        name: this.userData.routerPath.landing,
      });
    },
    callbackSetStateDocumentType(docType) {
      this.dataIsChange = true;
      try {
        let docBean = this.documentTypes.find(
          (d) => d.doc_code == docType.doc_code
        );
        docBean.filesReal = docType.filesReal;
        docBean.state = docType.state;
        docBean.totalFileSize =
          Number(docType.max_size * (1000 * 1000)) -
          Number(docType.filesRealSize);
        if (docBean.totalFileSize < 0) {
          docBean.state = "overlimit";
        }
        this.$forceUpdate();
      } catch (er) {
        console.error(er);
      }
    },
    checkBorderColor(state) {
      if (state == "overlimit") return "danger";
      if (state == "error" || state == "warning") return "warning";
    },
    checkHistoryUpload(docCode) {
      let history = this.userData.historyUploads.find(
        (i) => i.doc_code == docCode
      );
      return history.doc_upload_date !== null;
    },
    onReceiveNativeCommand(doc_code) {
      window["onReceiveNativeCommand"] = (commandName, payload) => {
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1;
        console.log("commandName: ", commandName, "  value: ", payload);
        if (commandName == "openCamera") {
          if (isAndroid) {
            document.getElementById("fileCamera_" + doc_code).click();
          } else {
            document.getElementById("fileBrowseIOS_" + doc_code).click();
          }
        } else if (commandName == "openGallery") {
          if (isAndroid) {
            document.getElementById("fileBrowseImage_" + doc_code).click();
          } else {
            document.getElementById("fileBrowseIOS_" + doc_code).click();
          }
        }
      };
      return true;
    },
  },
};
</script>
